
const WINDOWS_TO_IANA: Record<string, string> = {
  'GMT Standard Time': 'Europe/London',
  'W. Europe Standard Time': 'Europe/Berlin',
  'Turkey Standard Time': 'Europe/Istanbul',
  'Eastern Standard Time': 'America/New_York',
  'Central Standard Time': 'America/Chicago',
  'Mountain Standard Time': 'America/Denver',
  'Pacific Standard Time': 'America/Los_Angeles',
  UTC: 'UTC',
};

export const normalizeTimeZone = (timeZone?: string | null): string => {
  const tz = (timeZone || '').trim();
  if (!tz) return 'Europe/Tirane';
  return WINDOWS_TO_IANA[tz] ?? tz;
};

export const getCompanyTimeZone = (user?: any): string => {
  const tz = user?.companyTimeZone;
  if (typeof tz === 'string' && tz.trim()) {
    return normalizeTimeZone(tz);
  }
  return getStoredCompanyTimeZone() || 'Europe/Tirane';
};

export const setStoredCompanyTimeZone = (timeZone?: string | null) => {
  if (typeof window === 'undefined') return;
  const tz = normalizeTimeZone(timeZone);
  if (!tz) return;
  window.sessionStorage.setItem('companyTimeZone', tz);
};

export const getStoredCompanyTimeZone = (): string | null => {
  if (typeof window === 'undefined') return null;
  const tz = window.sessionStorage.getItem('companyTimeZone');
  return tz ? normalizeTimeZone(tz) : null;
};

export const toDateTimeLocalByTimeZone = (date: Date, timeZone: string): string => {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });

  const parts = formatter.formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';

  const y = get('year');
  const m = get('month');
  const d = get('day');
  const hh = get('hour');
  const mm = get('minute');

  return `${y}-${m}-${d}T${hh}:${mm}`;
};

export const formatDateByTimeZone = (value: unknown, timeZone: string): string | null => {
  if (value == null) return null;

  const raw = value instanceof Date ? value : new Date(value as string);
  if (Number.isNaN(raw.getTime())) return null;

  const hasTime = typeof value === 'string' && /[T\s]\d{2}:\d{2}/.test(value);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    ...(hasTime ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } : {}),
  });

  return formatter.format(raw);
};
